module.exports = __webpack_public_path__ + "static/pluto-4826b4a724959ef84427d9e7bd52d7fa.mp3";